import { query, collection, orderBy, onSnapshot, addDoc, setDoc, doc, deleteDoc } from "firebase/firestore";
import { getCompanyId, db, sendError } from "./firebase";

const listeners: CallableFunction[] = [];
var snapshotListener: Function | null = null;
var lastSnapshot: any | undefined = undefined;



export function registerSettingsSnapshotListener() {
    if (snapshotListener !== null) {
        return;
    }

    const q = query(collection(db, 'companies/' + getCompanyId() + '/admin'));
    //console.log("register settingsListener");
    snapshotListener =  onSnapshot(q, (data: any) => {
        var list: any[] = [];
        data.forEach(function (doc: any) {
            const d = doc.data();
            list.push({ ...d, id: doc.id });
        });
        
        lastSnapshot = list;
        listeners.forEach(callback => {
            callback(lastSnapshot);
        });
        
    }, (err) => {
        console.log("onSettingsChange error => " + err.message);
        sendError(err.message);
    })
}
export async function unregisterSettingsSnapshotListener() {
    if (snapshotListener !== null) {
        //console.log("unregister unregisterSettingsSnapshotListener");
        await snapshotListener();
        snapshotListener = null;
    }
}

export async function addSettingsListener(callback: CallableFunction) {
    listeners.push(callback);
    if (lastSnapshot !== undefined) {
        callback(lastSnapshot);
    }
}

function getSettingsById(id:string){
    if(lastSnapshot === undefined){
        return undefined;
    }
    for(var i=0; i< lastSnapshot.length; i++){
        if(lastSnapshot[i].id === id){
            return lastSnapshot[i];
        }
    }
    return undefined;
}

export function getSettings() {
    return getSettingsById("settings");
}

export function getManagerSettings() {
    return getSettingsById("managerSettings");
}